import React, { Fragment } from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import { H3, H5, P } from '../../../AbstractElements';
import { April, BlogPera, IMustExplainToYouHow } from '../../../Constant';

const BlogWidgets = () => {
  return (
    <Fragment>
      <Col sm='12' lg='6' xl='4' md='12' className='box-col-6 xl-50'>
        <Card className='height-equal'>
          <div className='calender-widget'>
            <div className='cal-img'></div>
            <div className='cal-date'>
              <H5>
                25
                <br />
                {April}
              </H5>
            </div>
            <CardBody className='cal-desc text-center'>
              <H3>{IMustExplainToYouHow}</H3>
              <P>{BlogPera}</P>
            </CardBody>
          </div>
        </Card>
      </Col>
    </Fragment>
  );
};
export default BlogWidgets;
